import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticateService } from '../services/authenticate.service';

@Injectable({
  providedIn: 'root'
})
export class LogueadoGuard  {
  constructor(
    private router: Router,
    private auth: AuthenticateService
  ){

  }
  async canActivate(){
      const isUserLoggedIn = await this.auth.validarToken();
      console.log('quedarce en login',isUserLoggedIn);
      if(!isUserLoggedIn){
        return true;
      }else{
        this.router.navigate(['control/home']);
      }

      return false;
    }
}
